import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

// @atlaskit
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';
import Button, { ButtonGroup } from '@atlaskit/button';
import DynamicTable from '@atlaskit/dynamic-table';

// @source
import { Messages } from '../../../components';
import { Report as APIs } from '../../../../server';
import DownloadDropdownMenu from './DownloadDropdownMenu';
import * as Styled from '../styled';

const initialState = {
  grid: [],
  isLoading: true,
  message: false,
};

class ExcelViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.unmount = false;
  }

  componentWillMount() {
    this.fetchReportExcel();
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  fetchReportExcel() {
    APIs.excel({
      data: {
        query: this.props.query,
        report: this.props.report,
      },
      success: (grid) => {
        this.setStateUnmount({
          isLoading: false,
          grid,
        });
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              component="Modal"
              items={messages}
              onClose={() => this.setState({ message: false })}
            />
          ),
        });
      },
    });
  }

  renderDynamicTableRows() {
    return this.state.grid.map(row => ({
      key: uuid(),
      cells: row.map(cell => ({
        content: cell,
      })),
    }));
  }

  render() {
    const isMobile = window.outerWidth < 768;

    return (
      <Styled.ExcelViewer>
        <Styled.ExcelButtonGroup>
          <ButtonGroup>
            <Button
              onClick={this.props.onClose}
              iconBefore={<ArrowLeftIcon size="small" />}
            >
              {isMobile ? '' : 'Turn Back'}
            </Button>
            <DownloadDropdownMenu model={this.props.model} />
          </ButtonGroup>
        </Styled.ExcelButtonGroup>
        <DynamicTable
          emptyView={this.state.message ? false : <i>Could not list any data.</i>}
          isFixedSize
          isLoading={this.state.isLoading}
          rows={this.renderDynamicTableRows()}
          rowsPerPage={250}
        />
        {this.state.message}
      </Styled.ExcelViewer>
    );
  }
}

ExcelViewer.propTypes = {
  model: PropTypes.shape().isRequired,
  onClose: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  report: PropTypes.string.isRequired,
};

export default ExcelViewer;
